function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.66 4.25A3.743 3.743 0 0 1 17.925 8a3.743 3.743 0 0 1-3.736-3.75A3.743 3.743 0 0 1 17.924.5a3.743 3.743 0 0 1 3.737 3.75zm3.204 12.25H11.01c.209-4.67 3.317-8.209 6.927-8.209 3.609 0 6.718 3.54 6.926 8.209zm8.053-9.25c0 1.52-1.228 2.75-2.74 2.75a2.745 2.745 0 0 1-2.74-2.75c0-1.52 1.229-2.75 2.74-2.75 1.512 0 2.74 1.23 2.74 2.75zm2.443 9.25H25.015c.205-3.468 2.528-6.041 5.172-6.041 2.645 0 4.968 2.573 5.173 6.041zM8.417 7.25c0 1.52-1.228 2.75-2.74 2.75a2.745 2.745 0 0 1-2.74-2.75c0-1.52 1.229-2.75 2.74-2.75 1.512 0 2.74 1.23 2.74 2.75zm2.443 9.25H.515c.205-3.468 2.528-6.041 5.173-6.041 2.644 0 4.967 2.573 5.172 6.041z",
  stroke: "#212121"
});

function SvgStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 17,
    viewBox: "0 0 36 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.278e890e.svg";
export { ForwardRef as ReactComponent };